<template>
  <div class="width-100 flex-column align-items-center justify-content-start padding-15 bg-slightGrey min-height">
    <van-field v-model="keywords" placeholder="请输入活动名称搜索" @keydown.enter="onRefresh" class="br-reg margin-b" />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="width-100">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div @click="gotoRightNow(item)" v-for="(item, key) in list" :key="key" class="br-reg bg-white border overflow-h width-100 margin-b">
          <van-image :src="item.picture_url" width="100%" :height="(bodyWidth - 30) * 0.5 + 'px'" fit="cover" />
          <div class="flex-row align-items-center justify-content-spaceBetween" style="height: 2rem; padding: 0 10px">
            <div class="darkgrey fm-sh-regular canNotWrap show-line-1 fs-mid line-height2">
              {{ item.name }}
            </div>
            <div class="fs-sml fm-sh-regular br-big go-right-now">立即前往</div>
          </div>
        </div>
        <van-empty v-if="list.length == 0" description="暂无活动" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { getExternalActivitiesLists } from '@/api/home';
import { Toast } from 'vant';
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      bodyWidth: '',
      keywords: '',
      pageNum: 0,
      refreshing: false
    };
  },
  beforeMount() {
    this.$nextTick(() => {
      this.bodyWidth = document.body.clientWidth;
    });
  },
  methods: {
    onLoad() {
      this.pageNum += 1;
      this.getList();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.list = [];
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNum = 0;
      this.refreshing = false;
      this.onLoad();
    },
    async getList() {
      await getExternalActivitiesLists({ name: this.keywords, page: this.pageNum }).then((res) => {
        if (res.code == 0) {
          this.list = this.list.concat(res.data);
          this.loading = false;
          if (this.list.length < this.pageNum * 30) {
            this.finished = true;
          }
        } else {
          Toast(res.msg);
        }
      });
      this.loading = false;
    },
    // 立即前往
    gotoRightNow(item) {
      location.href = item.url;
    }
  }
};
</script>
<style>
.go-right-now {
  border: 1px solid #2456f4;
  color: #2456f4;
  padding: 3px 10px;
  height: 70%;
  line-height: 100%;
  font-size: 12px;
  transform: scale(0.8);
}
</style>